import React from 'react';
import PropTypes from 'prop-types';

const LevelSelect = ({levels, descriptions, selectedLevel, onChange = () => {}}) => {
    return (
        <div className="order-form__item order-form__item_1">
            <div className="order-form__label">Experience Level</div>
            <div id="wrlevels-list-wrap" className="order-form__value level">
                <select id="wrlevel" name="wrlevel" value={selectedLevel.id} onChange={event => {
                    const selectedLevel = levels.filter(level => parseInt(event.target.value) === level.id)
                    onChange(selectedLevel[0].name)
                }}>
                    {levels.map(level => (
                        <option key={level.id} value={level.id}>{level.name}</option>
                    ))}
                </select>
                <div className="info-text__level">
                    <div className="level__item entry active">
                        {descriptions[selectedLevel.name]}
                    </div>
                </div>
            </div>
        </div>
    )
}

LevelSelect.propTypes = {
    levels: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
    })).isRequired,
    selectedLevel: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
    }).isRequired,
    descriptions: PropTypes.objectOf(PropTypes.string).isRequired,
    onChange: PropTypes.func,
};

export default LevelSelect;